import { usePrev } from '~src/hooks/usePrev';

type UseModalVisibleChangedReturn = {
  /** visibility changed */
  modalVisChanged: boolean;
  /** visibility changed NOT-VISIBLE -> VISIBLE */
  modalAppeared: boolean;
  /** visibility changed VISIBLE -> NOT-VISIBLE */
  modalDisappeared: boolean;
};

/**
 * Tracks modal visibility changes
 *
 * e.g wanna trigger query refetch on modal open? use `modalAppeared` as enabling condition
 *
 * @param modalVisible - `visible` state of modal
 */
export const useModalVisibleChanged = (
  modalVisible: boolean
): UseModalVisibleChangedReturn => {
  const prevModalVisible = usePrev(modalVisible);

  const modalVisChanged = modalVisible !== prevModalVisible;
  const modalAppeared = modalVisChanged && modalVisible;
  const modalDisappeared = modalVisChanged && !modalVisible;

  return { modalVisChanged, modalAppeared, modalDisappeared };
};
